import { ShoesState } from 'src/types'
import { generateLiningsGradient } from 'src/util/canvas'

export const tongueLiningsWithStandingTongueAndLace = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.tongueLinings.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(648, 115)
  ctx.quadraticCurveTo(710, 130, 733, 183)
  ctx.quadraticCurveTo(740, 212, 676, 235) // 左下_上
  ctx.quadraticCurveTo(681, 240, 681, 240) // 左下_下
  ctx.quadraticCurveTo(708, 231, 729, 211)
  ctx.quadraticCurveTo(747, 193, 733, 169)
  ctx.quadraticCurveTo(702, 124, 656, 112)
  ctx.quadraticCurveTo(648, 115, 648, 115)
  //   ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //   canvasResetter(ctx) // リセット

  ctx.beginPath()
  ctx.moveTo(619, 189)
  ctx.quadraticCurveTo(641, 214, 675, 239)
  ctx.quadraticCurveTo(701, 259, 736, 272)
  ctx.quadraticCurveTo(780, 285, 798, 255)
  ctx.quadraticCurveTo(809, 225, 817, 224)
  ctx.quadraticCurveTo(805, 213, 793, 227)
  ctx.quadraticCurveTo(776, 239, 765, 261)
  ctx.quadraticCurveTo(758, 273, 738, 266)
  ctx.quadraticCurveTo(708, 260, 678, 236)
  ctx.quadraticCurveTo(642, 209, 611, 176)
  ctx.quadraticCurveTo(619, 189, 619, 189)
  //   ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  const coordinates = { x0: 765, y0: 267, x1: 900, y1: 230 }
  const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
  ctx.fillStyle = gradient
  ctx.beginPath()
  ctx.moveTo(758, 272)
  ctx.quadraticCurveTo(773, 271, 778, 265)
  ctx.quadraticCurveTo(789, 252, 795, 230)
  ctx.quadraticCurveTo(776, 243, 770, 259)
  ctx.quadraticCurveTo(767, 266, 758, 272)
  // ctx.quadraticCurveTo()

  ctx.fill()
  ctx.closePath()
}

export const tongueLinings = (ctx: CanvasRenderingContext2D | null, state: ShoesState, x: number, y: number): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.tongueLinings.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(648 + x, 115 + y)
  ctx.quadraticCurveTo(710 + x, 130 + y, 733 + x, 183 + y)
  ctx.quadraticCurveTo(740 + x, 212 + y, 676 + x, 235 + y) // 左下_上
  ctx.quadraticCurveTo(681 + x, 240 + y, 681 + x, 240 + y) // 左下_下
  ctx.quadraticCurveTo(708 + x, 231 + y, 729 + x, 211 + y)
  ctx.quadraticCurveTo(747 + x, 193 + y, 733 + x, 169 + y)
  ctx.quadraticCurveTo(702 + x, 124 + y, 656 + x, 112 + y)
  ctx.quadraticCurveTo(648 + x, 115 + y, 648 + x, 115 + y)
  //   ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //   canvasResetter(ctx) // リセット

  const coordinates = { x0: 765, y0: 267, x1: 900, y1: 230 }
  const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
  ctx.fillStyle = gradient
  ctx.beginPath()
  // ctx.moveTo(758, 272)
  // ctx.quadraticCurveTo()

  ctx.fill()
  ctx.closePath()
}

export const lowOpeningLinings = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  const openingPattern = state.openingPattern.value
  if (openingPattern === 'quarterCut') return

  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.tongueLinings.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(590, 229)
  ctx.quadraticCurveTo(620, 264, 696, 286)
  ctx.quadraticCurveTo(749, 291, 779, 265)
  ctx.quadraticCurveTo(799, 241, 797, 241)
  ctx.quadraticCurveTo(799, 235, 808, 238)
  ctx.quadraticCurveTo(816, 237, 832, 247) // 右下
  ctx.quadraticCurveTo(838, 244, 825, 235)
  ctx.quadraticCurveTo(818, 229, 804, 228)
  ctx.quadraticCurveTo(784, 226, 775, 250)
  ctx.quadraticCurveTo(713, 296, 661, 265)
  ctx.quadraticCurveTo(630, 256, 590, 221)
  ctx.quadraticCurveTo(590, 229, 590, 229)
  //   ctx.quadraticCurveTo()

  // const coordinates = { x0: 600, y0: 200, x1: 860, y1: 300 }
  // const gradient = generateLiningsGradient(ctx, state.tongueLinings.color, coordinates)
  // ctx.fillStyle = gradient
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //   canvasResetter(ctx) // リセット
}
